<template>
  <div class="page-container">
    <el-row>
      <el-col :span="4" :xs="24" class="container-left">
        <div class="container-title">
          <span>组织架构</span>
        </div>
        <div class="head-container">
          <el-tree
            :data="orgTree"
            :props="defaultProps"
            :expand-on-click-node="false"
            ref="tree"
            node-key="id"
            :default-expand-all="isShowNode"
            @node-click="handleNodeClick"
            :highlight-current="true"
          >
            <span class="custom-tree-node tree-list" slot-scope="{ data }">
              <span>{{ data.name }}</span>
              <span class="tree-status" v-show="data.status == 0">无效</span>
            </span>
          </el-tree>
        </div>
      </el-col>
      <el-col :span="20" :xs="24" class="container-right">
        <div class="searchconditions" v-show="isShowSearch">
          <el-form :model="listForm" ref="listForm" inline>
            <el-form-item prop="contactPerson" label="姓名">
              <el-input
                v-model="listForm.contactPerson"
                placeholder="请输入姓名"
              ></el-input>
            </el-form-item>
            <el-form-item prop="telphone" label="电话">
              <el-input
                v-model="listForm.telphone"
                placeholder="请输入电话"
              ></el-input>
            </el-form-item>
            <el-form-item prop="sex" label="性别">
              <el-select v-model="listForm.sex" clearable placeholder="请选择">
                <el-option label="男" value="1"> </el-option>
                <el-option label="女" value="0"> </el-option>
                <el-option label="保密" value="2"> </el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="status" label="状态">
              <el-select
                v-model="listForm.status"
                clearable
                placeholder="请选择"
              >
                <el-option label="正常" value="1"> </el-option>
                <el-option label="失效" value="0"> </el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-search" type="cyan" @click="handleSearch"
                >查询</el-button
              >
              <el-button
                icon="el-icon-refresh"
                type="warning"
                @click="resetForm"
                >重置</el-button
              >
            </el-form-item>
          </el-form>
        </div>
        <el-row class="add-box">
          <el-col :span="12">
            <el-button
              :disabled="btnDisabled"
              class="add-button"
              type="primary"
              icon="el-icon-plus"
              size="mini"
              @click="handleAdd"
              >新增员工</el-button
            >
            <el-checkbox
              v-model="isChecked"
              fill="#20b2aa"
              @change="showSonList"
              >只展示当前部门直属人员</el-checkbox
            >
          </el-col>
          <div class="btn-group-right">
            <el-tooltip placement="top">
              <div slot="content">隐藏搜索</div>
              <el-button
                icon="el-icon-search"
                circle
                @click="showSearch"
              ></el-button>
            </el-tooltip>
            <el-tooltip placement="top">
              <div slot="content">刷新</div>
              <el-button
                icon="el-icon-refresh"
                circle
                @click="refreshBtn"
              ></el-button>
            </el-tooltip>
          </div>
        </el-row>
        <el-table
          :data="dataList"
          style="width: 100%"
          v-loading="loading"
          border
        >
          <el-table-column
            prop="code"
            label="员工编号"
            min-width="120"
            align="center"
          ></el-table-column>
          <el-table-column label="姓名" min-width="120" align="center">
            <template slot-scope="scope" style="position: relative">
              <span v-if="scope.row.contactPerson">{{
                scope.row.contactPerson
              }}</span>
              <span v-else>{{ scope.row.userName }}</span
              ><img
                src="../../../image/icon/icon-admin.svg"
                v-if="scope.row.isMain == 1"
                style="position: absolute; top: 0; right: 0; width: 35px"
              />
            </template>
          </el-table-column>
          <el-table-column
            prop="telphone"
            label="联系电话"
            min-width="120"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="sex"
            label="性别"
            align="center"
            min-width="120"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.sex == 0">女</span>
              <span v-else-if="scope.row.sex == 1">男</span>
              <span v-else>保密</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="rankName"
            label="职务"
            min-width="120"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="organizationName"
            label="所属机构"
            min-width="120"
            align="center"
          ></el-table-column>
          <el-table-column label="权限配置" min-width="120" align="center">
            <template slot-scope="scope">
              <span
                v-if="scope.row.isMain !== 1"
                @click="checkConfig(scope.row)"
                style="cursor: pointer; color: #409eff"
                >查看</span
              >
            </template>
          </el-table-column>
          <el-table-column
            prop="telphone"
            label="登录帐号"
            min-width="120"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="status"
            label="状态"
            align="center"
            min-width="120"
          >
            <template slot-scope="scope">
              <el-switch
                v-if="scope.row.isMain !== 1"
                v-model="scope.row.status"
                active-color="#13ce66"
                :active-value="1"
                :inactive-value="0"
                @change="statusChange(scope.row)"
              ></el-switch>
            </template>
          </el-table-column>
          <el-table-column
            prop="updateUserName"
            label="最后操作人"
            align="center"
            min-width="120"
          >
          </el-table-column>
          <el-table-column
            prop="updateTime"
            label="最后操作时间"
            align="center"
            width="160"
          >
          </el-table-column>
          <el-table-column
            prop="age"
            label="操作"
            align="center"
            min-width="160"
            class="handle-btn"
            fixed="right"
          >
            <template slot-scope="scope">
              <el-button
                v-if="scope.row.isMain !== 1"
                type="primary"
                size="mini"
                icon="el-icon-edit"
                @click="edit(scope.row)"
                >编辑</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          background
          layout="prev, pager, next, sizes, total, jumper"
          :page-sizes="[10, 15, 20]"
          :page-size="pageSize"
          :total="total"
          :current-page="pagenum"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
        >
        </el-pagination>
      </el-col>
    </el-row>
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      width="700px"
      @close="handleClose"
    >
      <el-form ref="form" :model="form" :rules="rules" label-width="80px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="员工编号" prop="code">
              <el-input v-model="form.code" placeholder="请输入员工编号" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="员工姓名" prop="contactPerson">
              <el-input
                v-model="form.contactPerson"
                placeholder="请输入员工姓名"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="性别" prop="sex">
              <el-radio-group v-model="form.sex">
                <el-radio :label="1">男</el-radio>
                <el-radio :label="0">女</el-radio>
                <el-radio :label="2">保密</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="排序号" prop="sort">
              <el-input
                v-model="form.sort"
                placeholder="请输入排序号"
                maxlength="5"
                oninput="value=value.replace(/[^\d]/g,'')"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="手机号码" prop="telphone">
              <el-input v-model="form.telphone" placeholder="请输入手机号码" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="邮箱" prop="email">
              <el-input
                v-model="form.email"
                placeholder="请输入邮箱"
                maxlength="50"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="登录帐号">
              <el-input value="同手机号" disabled />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="默认密码" prop="password">
              <el-input value="手机号后6位" disabled />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="归属部门" prop="organizationId">
              <treeselect
                v-model="form.organizationId"
                :options="orgTree"
                :normalizer="normalizer"
                :show-count="true"
                :clearable="false"
                @select="orgTreeSelected"
                placeholder="请选择归属部门"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="职务" prop="rankId">
              <el-select
                v-model="form.rankId"
                clearable
                placeholder="请选择职务"
                @change="changeValue"
              >
                <el-option
                  v-for="item in positionList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="权限配置">
              <el-input v-model="roleName" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="15">
            <el-tag
              v-for="tag in tags"
              :key="tag.name"
              closable
              :type="tag.type"
              @close="handleClear(tag)"
            >
              {{ tag.name }}
            </el-tag>
            <el-button
              size="mini"
              type="primary"
              class="add-config"
              icon="el-icon-plus"
              @click="addRolePower"
              >增加角色</el-button
            >
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="备注">
              <el-input
                v-model="form.remark"
                type="textarea"
                placeholder="请输入内容"
                maxlength="100"
                show-word-limit="true"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer">
        <el-button type="primary" @click="saveAddOrEdit()">确 定</el-button>
        <el-button @click="dialogVisible = false">取 消</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="增加权限"
      :visible.sync="dialogConfig"
      :close-on-click-modal="false"
      @close="handleConfigClose"
      width="600px"
    >
      <div>
        <div class="select-role">
          <el-form>
            <el-col :span="20">
              <el-form-item label="角色名称">
                <el-select
                  v-model="roleId"
                  clearable
                  @change="selectValue"
                  blur=""
                  placeholder="请选择角色"
                >
                  <el-option
                    v-for="item in roleList"
                    :key="item.roleId"
                    :label="item.roleName"
                    :value="item.roleId"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-form>
        </div>
        <div class="head-container">
          <el-tree
            :data="menuTree"
            :props="defaultPropsRole"
            show-checkbox
            :expand-on-click-node="false"
            ref="navTree"
            node-key="id"
            :default-expand-all="isShowNode"
            :default-checked-keys="navIdList"
          >
            <span class="custom-tree-node tree-list" slot-scope="{ data }">
              <span>{{ data.title }}</span>
            </span>
          </el-tree>
        </div>
      </div>
      <div slot="footer">
        <el-button @click="dialogConfig = false">取 消</el-button>
        <el-button type="primary" @click="saveAddRole">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="查看人员权限"
      :visible.sync="dialogConfigCheck"
      :close-on-click-modal="false"
      width="600px"
      @close="handleCheckConfigClose"
    >
      <div>
        <div class="person-info">
          <span>编号：{{ personConfig.code }}</span>
          <span>姓名：{{ personConfig.name }}</span>
        </div>
        <div class="head-container">
          <el-tree
            :data="checkMenuTree"
            :props="defaultPropsRole"
            show-checkbox
            :expand-on-click-node="false"
            ref="navListTree"
            node-key="id"
            :default-expand-all="isShowNode"
            :default-checked-keys="getNavList"
            @check="checkboxChange"
          >
            <div
              class="custom-tree-node tree-list tree-list-check"
              slot-scope="{ data }"
            >
              <span>{{ data.title }}</span>
              <!-- <el-checkbox-group
                v-model="data.btns"
                v-if="data.children && data.children.length == 0"
                class="btn-checkbox"
              >
                <el-checkbox
                  @change="(checked) => handleMenuBtns(checked, data, item)"
                  :checked="item.checked"
                  v-for="item in data.menuBtns"
                  :label="item.id"
                  :key="item.id"
                  disabled
                  >{{ item.name }}</el-checkbox
                >
              </el-checkbox-group> -->
            </div>
          </el-tree>
        </div>
      </div>
      <div slot="footer">
        <el-button type="primary" @click="dialogConfigCheck = false"
          >关 闭</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  queryCompanyPersonPageList, //人员分页列表
  // getOrganizationList, //
  companyQueryOrganizationByCurrentUser, //组织机构树
  getCompanyRolesLi, //角色列表
  getAllCompanyNavigation, //所有菜单列表
  getAdminNavigationByUserId,
  getPermissionNaviListByCompanyRolesId, //角色分配权限回显
  saveOrEditCompanyUser, //新增、编辑人员
  updateCompanyUserStatus, // 修改人员状态
  getCompanyPersonNaviList, //查看人员权限 回显
  queryCompanyPositionList, //获取职位列表
  getCompanyPersonObject, //单个人员详情(编辑)
} from "@/common/api.js";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
export default {
  components: { Treeselect },
  props: {},
  data() {
    return {
      tags: [],
      dialogVisible: false,
      dialogConfig: false,
      dialogConfigCheck: false,
      isShowNode: true,
      loading: false,
      btnDisabled: false,
      rolesTags: [],
      rules: [],
      orgTree: [],
      // 员工列表
      dataList: [],
      // 职务列表
      positionList: [],
      // 角色列表
      roleList: [],
      //权限菜单列表
      menuTree: [],
      // 拥有菜单id列表
      navIdList: [],
      //查看用户权限
      getNavList: [],
      navTrees: [],
      personConfig: {
        name: "",
        code: "",
      },
      defaultProps: {
        children: "systemOrganizations",
        label: "name",
      },
      defaultPropsRole: {
        children: "children",
        label: "title",
      },
      normalizer(node) {
        if (
          node.systemOrganizations == null ||
          node.systemOrganizations == "null"
        ) {
          delete node.systemOrganizations;
        }
        return {
          id: node.id,
          label: node.name,
          children: node.systemOrganizations,
        };
      },
      total: 0,
      pageSize: 10,
      pagenum: 1,
      // 弹出层标题
      title: "",
      //表单验证
      rules: {
        contactPerson: [
          { required: true, validator: this.testName, trigger: "blur" },
        ],
        code: [{ required: true, validator: this.testCode, trigger: "blur" }],
        telphone: [
          { required: true, validator: this.testPhone, trigger: "blur" },
        ],
        sex: [{ required: true, message: "请选择员工性别", trigger: "blur" }],
        organizationId: [
          { required: true, message: "请选择所属部门", trigger: "blur" },
        ],
        rankId: [{ required: true, message: "请选择职务", trigger: "blur" }],
      },
      // 所属机构id
      parentId: "",
      //新增、编辑
      form: {
        userId: null,
        contactPerson: "",
        telphone: "",
        organizationId: null,
        rankId: null,
        code: null,
        sex: null,
        sort: null,
        remark: "",
        companyUserRolePers: [],
      },
      roleName: "",
      defaultRoleId: null,
      roleId: null,
      // 查询
      listForm: {
        contactPerson: "",
        telphone: null,
        sex: "",
        status: null,
      },
      // 是否显示查询框
      isShowSearch: true,
      checkMenuTree: [],
      isChecked: false,
    };
  },
  watch: {},
  computed: {},
  methods: {
    handleNodeClick(data) {
      var id = data.id;
      this.parentId = id;
      this.btnDisabled = data.status == 0 ? true : false;
      this.queryPersonList(id);
    },
    // 组织架构树
    getOrganizationTree(pid) {
      companyQueryOrganizationByCurrentUser().then((res) => {
        console.log("res :>> ", res);
        if (res.errorCode == 200 && res.data) {
          this.orgTree = [];
          this.orgTree.push(res.data);
          if (pid) {
            this.$nextTick(() => {
              this.$refs.tree.setCurrentKey(pid);
            });
          } else {
            var id = res.data.id;
            this.queryPersonList(id);
            this.parentId = id;
            this.$nextTick(() => {
              this.$refs.tree.setCurrentKey(id);
            });
          }
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 员工列表
    queryPersonList(id) {
      this.loading = true;
      var byParent = "";
      if (this.isChecked) {
        byParent = "yse";
      } else {
        byParent = "";
      }
      var params = {
        pageSize: this.pageSize,
        pagenum: this.pagenum,
        data: {
          organizationId: id,
          byParent: byParent,
          contactPerson: this.listForm.contactPerson,
          telphone: this.listForm.telphone,
          sex: this.listForm.sex,
          status: this.listForm.status,
        },
      };
      queryCompanyPersonPageList(params).then((res) => {
        console.log("res :>> ", res);
        this.loading = false;
        if (res.errorCode == 200) {
          this.dataList = res.data.list;
          this.total = res.data.total;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 部门直属员工列表
    showSonList() {
      this.queryPersonList(this.parentId);
    },
    // 职务列表
    queryCompanyPositionList(id) {
      var data = {
        organizationId: id,
      };
      queryCompanyPositionList(data).then((res) => {
        if (res.errorCode == 200) {
          console.log(res.data);
          this.positionList = res.data;
        }
      });
    },
    // 角色列表
    getCompanyRolesLi() {
      var data = {
        roleType: "systemRole",
      };
      getCompanyRolesLi(data).then((res) => {
        if (res.errorCode == 200) {
          console.log(res.data);
          this.roleList = res.data;
        } else {
          this.$message.error(res.msg);
        }
      });
    },

    //菜单列表
    getAllCompanyNavigation() {
      // var data = {
      //   navType: "system",
      // };
      var data = {
        userId: sessionStorage.getItem("userId"),
      };
      this.menuTree = [];
      // getAllCompanyNavigation(data).then((res) => {
      getAdminNavigationByUserId(data).then((res) => {
        if (res.errorCode == 200) {
          if (res.data) {
            this.menuTree.push(res.data);
            console.log(this.menuTree);
            treeMap(this.menuTree);
            function treeMap(params) {
              params.map((item) => {
                item.disabled = true;
                if (item.children && item.children.length > 0) {
                  treeMap(item.children);
                }
              });
            }
            console.log(this.menuTree);
          }
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    //显示隐藏搜索框
    showSearch() {
      this.isShowSearch = !this.isShowSearch;
    },
    // 刷新
    refreshBtn() {
      this.queryPersonList(this.parentId);
    },
    //选择所属机构
    orgTreeSelected(node) {
      console.log(node);
      this.form.organizationId = node.id;
      this.form.rankId = null;
      this.roleName = "";
      this.queryCompanyPositionList(node.id);
    },
    // 选择职务
    changeValue(val) {
      console.log(val);
      this.$forceUpdate();
      let obj = {};
      console.log(this.roleList);
      this.positionList.map((item) => {
        console.log(item);
        if (item.id == val) {
          obj = item;
        }
      });
      this.roleName = obj.roleName;
      this.defaultRoleId = obj.roleId;
    },
    // 增加角色
    addRolePower() {
      if (!this.form.rankId) {
        this.$message.error("请先选择职务");
      } else {
        this.dialogConfig = true;
      }
    },
    // 选择角色并增加
    selectValue(val) {
      this.$nextTick(() => {
        this.$refs.navTree.setCheckedKeys([]);
      });
      console.log(val);
      var data = {
        roleId: val,
      };
      getPermissionNaviListByCompanyRolesId(data).then((res) => {
        if (res.errorCode == 200) {
          var list = [];
          if (res.data && res.data.length > 0) {
            res.data.forEach((item) => {
              list.push(item.id);
            });
          }
          this.navIdList = list;
        }
      });
    },
    //保存增加的角色
    saveAddRole() {
      console.log(this.roleId);
      console.log(this.defaultRoleId);
      if (this.roleId == this.defaultRoleId) {
        this.$message.error("角色已存在");
        return;
      }
      var roles = this.form.companyUserRolePers;
      if (roles.length > 0) {
        for (var k in roles) {
          if (roles[k].roleId == this.roleId) {
            this.$message.error("已经添加过了");
            return;
          }
        }
      }
      console.log(this.roleList);
      let obj = {};
      this.roleList.map((item) => {
        if (item.roleId == this.roleId) {
          obj = item;
        }
      });
      console.log(obj);
      this.form.companyUserRolePers.push({ roleId: this.roleId });
      this.tags.push({ name: obj.roleName, type: "success" });
      this.dialogConfig = false;
    },
    //删除增加的角色
    handleClear(tag) {
      console.log(tag);
      this.tags.splice(this.tags.indexOf(tag), 1);
      this.form.companyUserRolePers.splice(
        this.form.companyUserRolePers.indexOf(tag),
        1
      );
      console.log(this.form.companyUserRolePers);
    },
    // 新增人员
    handleAdd() {
      this.reset();
      this.dialogVisible = true;
      this.title = "新增员工";
      this.form.organizationId = this.parentId;
      this.queryCompanyPositionList(this.parentId);
      console.log(this.form);
    },
    // 编辑人员
    edit(row) {
      console.log(row);
      this.reset();
      this.dialogVisible = true;
      this.title = "编辑员工";
      var data = {
        userId: row.userId,
      };
      getCompanyPersonObject(data).then((res) => {
        console.log(res);
        if (res.errorCode == "200") {
          this.form = {
            userId: res.data.userId,
            contactPerson: res.data.contactPerson,
            telphone: res.data.telphone,
            organizationId: res.data.organizationId,
            rankId: res.data.rankId,
            code: res.data.code,
            sex: res.data.sex,
            sort: res.data.sort,
            remark: res.data.remark,
            companyUserRolePers: [],
          };
          if (
            res.data.companyUserRolePers &&
            res.data.companyUserRolePers.length > 0
          ) {
            res.data.companyUserRolePers.map((item) => {
              this.tags.push({ name: item.roleName, type: "success" });
              this.form.companyUserRolePers.push({ roleId: item.roleId });
            });
          }
          var params = {
            organizationId: row.organizationId,
          };
          queryCompanyPositionList(params).then((result) => {
            if (result.errorCode == 200) {
              console.log(result.data);
              this.positionList = result.data;
              this.positionList.map((item) => {
                if (item.id == res.data.rankId) {
                  this.roleName = item.roleName;
                  this.defaultRoleId = item.roleId;
                }
              });
            }
          });
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 新增或编辑保存
    saveAddOrEdit() {
      console.log(this.form);
      this.$refs.form.validate((valid) => {
        if (valid) {
          saveOrEditCompanyUser(this.form).then((res) => {
            if (res.errorCode == "200") {
              this.queryPersonList(this.parentId);
              this.dialogVisible = false;
              this.$message({
                type: "success",
                message: "保存成功",
              });
            } else {
              this.$message.error(res.msg);
            }
          });
        }
      });
    },
    closeDialog() {
      this.dialogVisible = false;
    },
    //变更状态
    statusChange(row) {
      console.log(row);
      var department = row.contactPerson;
      var mess = "";
      let text = "";
      if (row.status == 1) {
        text = "有效";
      } else if (row.status == 0) {
        text = "无效";
        mess = "设置为无效后，该人员将无法登录平台";
      }
      const h = this.$createElement;
      this.$msgbox({
        title: "提示",
        message: h("p", null, [
          h(
            "h3",
            null,
            '是否将 "' + department + '" 的状态变为 "' + text + '" ?',
            "警告"
          ),
          h("h4", { style: "color:#a0a0a0" }, mess),
        ]),
        showCancelButton: true,
        closeOnClickModal: false,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            done();
            var params = {
              userId: row.userId,
              status: row.status,
            };
            updateCompanyUserStatus(params).then((res) => {
              if (res.errorCode == "200") {
                this.$message({
                  type: "success",
                  message: "操作成功",
                });
              } else {
                this.$message.error(res.msg);
                if (row.status == 1) {
                  row.status = 0;
                } else if (row.status == 0) {
                  row.status = 1;
                }
              }
            });
          } else {
            done();
            if (row.status == 1) {
              row.status = 0;
            } else if (row.status == 0) {
              row.status = 1;
            }
            console.log(row.status);
          }
        },
      })
        .then((action) => {
          console.log("确定");
        })
        .catch(() => {
          console.log("取消");
        });
    },
    // 表单数据清空
    reset() {
      this.form = {
        userId: null,
        contactPerson: "",
        telphone: "",
        organizationId: null,
        rankId: null,
        code: null,
        sex: null,
        sort: null,
        remark: "",
        companyUserRolePers: [],
      };
      this.roleName = "";
      this.tags = [];
    },
    //弹框关闭 重置form
    handleClose() {
      this.$nextTick(() => {
        this.$refs["form"].resetFields();
        this.roleName = "";
        this.tags = [];
      });
    },
    // 监听配置权限dialog
    handleConfigClose() {
      this.$nextTick(() => {
        this.$refs.navTree.setCheckedKeys([]);
        this.roleId = null;
      });
    },
    //监听查看权限弹框
    handleCheckConfigClose() {
      this.$nextTick(() => {
        this.$refs.navListTree.setCheckedKeys([]);
      });
    },
    //选页
    handleCurrentChange(cpage) {
      this.pagenum = cpage;
      var id = this.parentId;
      this.queryPersonList(id);
    },
    handleSizeChange(psize) {
      this.pagesize = psize;
      var id = this.parentId;
      this.queryPersonList(id);
    },
    // 查询
    handleSearch() {
      var id = this.parentId;
      this.pagenum = 1;
      this.queryPersonList(id);
    },
    resetForm() {
      this.$nextTick(() => {
        this.pagenum = 1;
        this.$refs["listForm"].resetFields();
        var id = this.parentId;
        this.queryPersonList(id);
      });
    },
    // 查看权限
    checkConfig(row) {
      console.log(row);
      // this.getNavList = [];
      this.checkMenuTree = this.menuTree;
      var list = [];
      this.personConfig.name = row.contactPerson;
      this.personConfig.code = row.code;
      var params = {
        userId: row.userId,
        isMain: row.isMain,
        rankId: row.rankId,
      };
      this.dialogConfigCheck = true;
      getCompanyPersonNaviList(params).then((res) => {
        if (res.errorCode == "200") {
          console.log(res.data);
          res.data.forEach((item) => {
            list.push(item.id);
          });
          var dataList = res.data;
          this.getNavList = list;
          console.log(this.getNavList);
          getMenuBtns(this.checkMenuTree);
          console.log(this.checkMenuTree);
          function getMenuBtns(array) {
            array.forEach((item) => {
              item.btns = [];
              for (var k in dataList) {
                if (dataList[k].id == item.id) {
                  item.btns = dataList[k].btns;
                }
              }
              if (item.children && item.children.length > 0) {
                getMenuBtns(item.children);
              }
            });
          }
        } else {
          this.$message.error(res.msg);
        }
      });
    },

    // 节点被点击发生变化
    checkboxChange(data, json) {
      this.selectNav = [];
      var ridsb = this.$refs.navTree
        .getCheckedNodes()
        .concat(this.$refs.navTree.getHalfCheckedNodes());
      if (ridsb.length > 0) {
        ridsb.forEach((item) => {
          var obj = {
            roleId: this.roleId,
            naviId: "",
            naviName: "",
          };
          obj.naviId = item.id;
          obj.naviName = item.title;
          this.selectNav.push(obj);
        });
      }
      var nodeArr = json.checkedNodes;
      var isHaveNode = false;
      nodeArr.forEach((item) => {
        if (item.id == data.id) {
          isHaveNode = true;
        }
      });
      if (!isHaveNode) {
        data.btns = [];
        if (data.children && data.children.length > 0) {
          getNav(data.children);
        }
        function getNav(array) {
          array.forEach((item) => {
            item.btns = [];
            if (item.children && item.children.length > 0) {
              getNav(item.children);
            }
          });
        }
      }
    },
    testCode(rule, value, callback) {
      if (value) {
        if (value.length > 20) {
          callback(new Error("最多输入20个字符"));
        }
        var str = /^[a-z\d]*$/i;
        if (!value.match(str)) {
          callback(new Error("仅支持输入数字、字母"));
        }
        callback();
      } else {
        callback(new Error("请输入员工编号"));
      }
    },
    testName(rule, value, callback) {
      if (value) {
        if (value.length > 20) {
          callback(new Error("最多输入20个字符"));
        }
        var str =
          /[`~!@#$%^&*()_\-+=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘'，。、]/;
        if (value.match(str)) {
          callback(new Error("不能输入特殊字符"));
        }
        callback();
      } else {
        callback(new Error("请输入员工姓名"));
      }
    },
    // 验证手机号
    testPhone(rule, value, callback) {
      if (value) {
        var checkRule = /^1[3456789]\d{9}$/;
        var mobile = checkRule.test(value);
        if (!mobile) {
          callback(new Error("手机号码格式不正确，请重新输入"));
        }
        callback();
      } else {
        callback(new Error("请输入手机号"));
      }
    },
  },
  created() {},
  mounted() {
    this.getOrganizationTree(this.parentId);
    this.getAllCompanyNavigation();
    this.getCompanyRolesLi();
  },
};
</script>
<style lang="less" scoped>
.page-container {
  height: 100%;
  margin-left: -20px;
  .el-row {
    height: 100%;
  }
  .add-config {
    margin-left: 15px;
    margin-top: 3px;
  }
  .el-tag {
    margin-left: 10px;
  }
  .container-left {
    padding: 0 10px;
    background-color: #ffffff;
    height: 100%;
    width: 17%;
    .container-title {
      height: 50px;
      line-height: 50px;
      border-bottom: 1px solid #eee;
      .el-icon-arrow-down {
        margin-left: 15px;
        font-weight: 800;
      }
      .expand-btn {
        img {
          width: 15px;
          height: 15px;
          vertical-align: middle;
          margin-left: 5px;
          transform: rotate(0deg);
          transition: transform 0.5s;
        }
        .active {
          transform: rotate(180deg);
          transition: transform 0.5s;
        }
      }
    }
  }
  .container-right {
    border-radius: 6px;
    margin-left: 12px;
    width: calc(83% - 12px);
    .searchconditions {
      background: #fff;
      border-radius: 6px;
      margin-top: 10px;
      padding: 12px 15px;
      box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.2);
      .el-form {
        .el-form-item {
          display: inline-block;
          margin-right: 10px;
          vertical-align: top;
          margin: 5px 15px 5px 0px;
          /deep/.el-button {
            padding: 8px 15px;
            font-size: 12px;
            border-radius: 3px;
          }
        }
      }
    }
  }
  .select-role {
    height: 60px;
  }
  .person-info {
    margin-bottom: 20px;
    span {
      font-size: 16px;
      font-weight: 600;
    }
    span:nth-child(2) {
      margin-left: 20px;
    }
  }
  .el-row {
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
    .add-box {
      background: #ffffff;
      margin-top: 10px;
      padding: 10px;
      .add-button {
        margin-right: 20px;
      }
    }
    .add-btn {
      float: left;
      padding: 0;
      margin-top: 5px;
      margin-bottom: 10px;
      .el-button {
        padding: 8px 15px;
        font-size: 12px;
        border-radius: 3px;
      }
    }
    .btn-group-right {
      float: right;
      .el-button {
        padding: 8px;
      }
      span {
        display: inline-block;
        vertical-align: top;
        font-size: 20px;
        padding: 8px;
      }
    }
  }

  .btn-checkbox {
    /deep/.el-checkbox__input.is-checked .el-checkbox__inner,
    .el-checkbox__input.is-indeterminate .el-checkbox__inner {
      background-color: #13ce66;
      border-color: #13ce66;
    }
    /deep/.el-checkbox__input.is-checked + .el-checkbox__label {
      color: #13ce66;
    }
    /deep/.el-checkbox__input.is-disabled.is-checked .el-checkbox__inner {
      background-color: #13ce66;
      border-color: #13ce66;
    }
  }
  /deep/.el-input__inner,
  /deep/.el-form-item__content {
    height: 34px;
    line-height: 34px;
  }
  /deep/.el-input__icon,
  /deep/.el-form-item__label {
    line-height: 34px;
  }
  .tree-list {
    font-size: 14px;
    .tree-status {
      font-size: 12px;
      background-color: #f0f0f0;
      padding: 2px 3px;
      color: red;
    }
  }
  .tree-list-check {
    color: #333333;
    font-weight: 600;
    display: table;
  }
  /deep/.el-checkbox__input.is-disabled.is-checked .el-checkbox__inner {
    background-color: #409eff;
    border-color: #409eff;
  }
  .el-checkbox-group {
    display: inline-block;
    margin-left: 20px;
    white-space: normal;
    vertical-align: middle;
    width: 78%;
    padding: 6px 0;
  }
  /deep/.el-tree-node__content {
    height: auto;
    min-height: 30px;
  }
  /deep/.el-tree-node:focus > .el-tree-node__content {
    background-color: #e4e4e4;
  }
  /deep/.el-tree--highlight-current
    .el-tree-node.is-current
    > .el-tree-node__content {
    background-color: #e4e4e4;
  }
  .head-container {
    /deep/.el-tree-node {
      white-space: initial;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/view/user/baseInfo/personManage.vue